import {loginSelectors} from 'features/login/redux';
import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {AdminResourceTypeUnion} from 'types/diplomat/settings/adminroles/AdminResourceType';

export const useIsPermittedByRole = () => {
   const rolesMap = useSelector(loginSelectors.getResourcesMap);

   const isPermittedByRole = useCallback(
      (permission: AdminResourceTypeUnion) => {
         return rolesMap[permission];
      },
      [rolesMap]
   );

   return isPermittedByRole;
};
